export default {
    'verification-message': 'A message containing a verification code has been sent to {phone}. Enter the code to continue.',
}